import { deviceTypeName } from "../../Everou/_constants";
import { TimeHelper } from "../../Everou/_helpers/TimeHelper";

export const DEVICE_STATUS = {
    ACTIVE: "active",
    NOT_CONFIGURED: "not_configured",
    NOT_SOLD: "not_sold",
};

export function formatDeviceDate(isoString) {
    if (!isoString)
        return "-";
    return TimeHelper.isoStringToLocalTimezoneFormat(isoString, TimeHelper.getTimeFormats().DATE);
}

export function formatDeviceDay(isoString) {
    if (!isoString)
        return "-";
    return TimeHelper.isoStringToLocalTimezoneFormat(isoString, TimeHelper.getTimeFormats().DATE_NO_TIME);
}

export function formatDeviceType(type) {
    const name = deviceTypeName(type);
    return name === "NOT FOUND" ? String(type ?? "-") : name;
}
